import { SoignantDto } from "@jack-sparrow-libraries/angular-business-commons";
import { SoignantApiModel } from "@featuresAY/idel-web-ay/models/soignant-api.model";
import { CoordonneesMapperService } from "@featuresAY/idel-web-ay/service/mappers/coordonnees-mapper.service";

export class SoignantMapperService {
	static toDto(soignant: SoignantApiModel): SoignantDto {
		return {
			__brand: "DTO",
			id: soignant.id,
			ico: soignant.ico,
			idnat: soignant.idnat,
			initiales: soignant.initiales,
			nom: soignant.nom,
			personneId: soignant.personneId,
			personneTitulaireId: soignant.personneTitulaireId,
			prenom: soignant.prenom,
			pseudo: soignant.pseudo,
			rpps: soignant.rpps,
			type: soignant.type,
			codeSpecialiteTitulaire: soignant.codeSpecialiteTitulaire,
			coordonnees: soignant.coordonnees
				? CoordonneesMapperService.coordonneesSimplifieToCoordonneesSimplifieAvecKmWSDTO(soignant.coordonnees)
				: null,
		};
	}
}
